import { Modal as ModalMui, Box, IconButton } from "@mui/material";
import styled from "styled-components";

export const ModalMuiStyled = styled(ModalMui)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BoxStyled = styled(Box)<{ maxWidth: string }>`
  && {
    max-height: 95vh;
    height: fit-content;
    overflow: hidden;
    align-items: center;
    isolation: isolate;
    width: 100%;
    max-width: ${(props) => props.maxWidth};
    background: #ffffff;
    box-shadow: 0px 8px 20px rgba(16, 18, 35, 0.2);
    border-radius: 16px;
    box-sizing: border-box;
    padding: 20px 32px;
    position: relative;
    @media (max-width: 720px) {
      margin: 10px;
      padding: 20px 10px;
    }
  }
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: 10px;
  right: 10px;
  color: #777986;
`;
